module.exports = __webpack_public_path__ + "static/media/icon_scooter.8377b818.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_scooter.svg
// module id = 1847
// module chunks = 0